import request from '../../utils/request'
import prefix from '../prefix'
import auth from '../auth'

/***
 * 获取货币K线图
 * @param data
 * @returns {AxiosPromise}
 */
export const vcMarketKline = data => {
  return request({
    url: prefix + '/vc/market/kline',
    method: 'post',
    data
  })
}

/***
 * 获取行情列表[带价格数据]
 * @param data
 * @returns {AxiosPromise}
 */
export const vcMarketList = data => {
  return request({
    url: prefix + '/vc/market/list',
    method: 'post',
    data
  })
}

/***
 * 获取币种列表[不带行情数据 只做静态展示]
 * @param data
 * @returns {AxiosPromise}
 */
export const vcList = data => {
  return request({
    url: prefix + auth + '/vc/list',
    method: 'post',
    data
  })
}

/***
 * 获取货币最新行情
 * @param data
 * @returns {AxiosPromise}
 */
export const vcMarketDetail = data => {
  return request({
    url: prefix + '/vc/market/detail',
    method: 'post',
    data
  })
}

/***
 * 获取货币最新行情
 * @param data
 * @returns {AxiosPromise}
 */
export const vcMarketDetailKline = data => {
  return request({
    url: prefix + '/vc/market/detail-kline',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/vc/vc.js